
import {  Component } from '@angular/core';
import {MessageService} from 'primeng/api';
import { UserService } from '../../@core/data/users.service';
import { ApiService } from '../../shared/api.service';
import { FormBuilder, FormGroup,Validators} from '@angular/forms';
import { NbDateService } from '@nebular/theme';
import { NbDialogService } from '@nebular/theme';
import {ResendEmailComponent} from './resend-email.component'
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'nb-forgot-password',
  styleUrls: ['./forgot-password.component.scss'],
  templateUrl: './forgot-password.component.html',
  providers: [MessageService]
})
export class ForgotPasswordComponent{

  readonly emailValidate = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	ForgotPassForm: FormGroup;
	alertFlag:any = 0;
	alertFlag1:any = 0;
	messagealertflag;
	showOtpModal = false;
	otp:any
	resendcount:number = 0;
	resendmessage:boolean =false;
 
  constructor(private fb: FormBuilder,
    protected dateService: NbDateService<Date>,
	private router : Router,
    protected api : ApiService,
		private dialogService: NbDialogService,
    )
     {  
    
    
    }

    ngOnInit() {
				this.ForgotPassForm = this.fb.group({
     		emailaddressCtrl:['',[Validators.required, Validators.pattern(this.emailValidate)]]
       });
    }
     
	reSendOtp(){

    try {
	  this.resendcount++;
	  var requestemail = this.ForgotPassForm.controls.emailaddressCtrl.value 

      this.api.updateAndGetOtp(requestemail).subscribe(
        (response: any) => {
          if (response['status'] === 200) {
            console.log('OTP sent successfully!');
			this.resendmessage = true;
			setTimeout(() => {
				this.resendmessage = false;
			}, 2000)
          } else {
            console.log('Failed to send Otp.');
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.log('Error generating OTP:', error);
    }
  }

   checkOtp() {
	var requestemail = this.ForgotPassForm.controls.emailaddressCtrl.value ;
    this.api.verifyOtp(requestemail,this.otp).subscribe(
        (response: any) => {
          if (response['status'] === 200) {
			localStorage.setItem('email', requestemail);
			// C-1: carry the single-use reset token returned by verifyOtp.
			if (response['resetToken']) { localStorage.setItem('resetToken', response['resetToken']); }
			this.router.navigate(['/auth/changePassword']);
          } else {
			console.log('Wrong Otp Please Check')
            
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

	cancel() {
		this.showOtpModal = false;
	}

    onSubmit(){
		var check_validation;
		this.ForgotPassForm.controls.emailaddressCtrl.markAsDirty();
		if (this.ForgotPassForm.valid) {
			check_validation = true;
		} else {
			check_validation = false;
		}
		if (check_validation) {
			this.showOtpModal = true;
			this.reSendOtp()

		}else{
			alert("Enter Your email")
		}  
		//  var check_validation;
		//  var requestemail = this.ForgotPassForm.controls.emailaddressCtrl.value ;
		//  this.ForgotPassForm.controls.emailaddressCtrl.markAsDirty();
		//  if(this.ForgotPassForm.valid){	
		// 	check_validation = true;
		// 	this.alertFlag = 0;
		//  }else{
		// 	check_validation = false;
		// 	this.alertFlag = 1;
		//  }
		//  if(check_validation){

		// 	this.api.ForgotPassword(requestemail)
		// 	.subscribe(
		// 			(data: any) => {
		// 			if(data['status'] == 200){
							
		// 					this.dialogService.open(ResendEmailComponent, {
		// 					context: {
		// 						email: requestemail,							
		// 					},
		// 			});

		// 			}else if(data['status'] == 400){
		// 				this.alertFlag1=1;
		// 					this.messagealertflag =data['message'];                               

		// 			}else{

		// 			}       
		// 					 err => console.error(err)
		// 	});

		//  }
    } 
}
